import BoardList from "@/components/BoardList";
import { getAds, getRelatedBoards } from "@/services";
import { getExpsValue } from "@/tracker/abTest";
import pvTracker from "@/tracker/report/pvTracker";
import getPageData from "@/tracker/shared/getPageData";
import useRequest from "@/utils/useReq";
import { useSetState } from "ahooks";
import { last } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";

// 同在画板
export default function PinRelatedBoardList({
  pinId,
  isModal,
  onFirstLoad,
  initList,
  fileId,
}) {
  const [query, setQuery] = useSetState({
    max: initList?.length ? last(initList).seq : 0,
    pinId: null,
  });
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState(initList || []);
  const [ads, setAds] = useState([]);
  const [scrollableTarget, setScrollableTarget] = useState(null);
  useRequest(
    async () => {
      const { max, pinId } = query;

      if (!pinId) {
        return;
      }

      const result = await getRelatedBoards({
        pin_id: pinId,
        limit: 20,
        ...(max ? { max } : null),
      });

      const boards = result?.boards || [];

      // 加载后回调，自由在第一次加载才会掉
      if (onFirstLoad && max === 0) {
        onFirstLoad(boards);
      }

      if (boards.length <= 0) {
        setHasMore(false);
      }

      setDataSource(dataSource.concat(boards));
    },
    {
      refreshDeps: [query],
    }
  );

  useRequest(async () => {
    const result = await getAds({
      positions: [52],
      file_id: fileId,
    });

    // ab实验：0: 只展示人工投放内容，1: 人工投放内容+智能生成投放内容
    const abTestStrategy = await getExpsValue("abtest_ad_strategy", "1");

    setAds(
      result?.reduce((result, item) => {
        if (item) {
          if (
            abTestStrategy == 0 &&
            item.material?.link?.includes("from=auto")
          ) {
            return result;
          }

          result.push({
            ...item,
            board_id: `recommend-${item.material.id}`,
            type: "recommend",
          });
        }
        return result;
      }, []) || []
    );
  });

  const onLoadMore = useCallback(() => {
    if (dataSource.length > 0) {
      const last = dataSource[dataSource.length - 1];
      setQuery({
        max: last.seq || last.board_id,
      });
      pvTracker(getPageData());
    }
  }, [dataSource, setQuery]);

  useEffect(() => {
    if (pinId) {
      setHasMore(true);
      setDataSource(initList || []);
      setQuery({
        max: initList?.length ? last(initList).seq : 0,
        pinId,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pinId, setQuery]);

  useEffect(() => {
    if (isModal) {
      setScrollableTarget(document.querySelector(".pinDetailModal"));
    }
  }, [isModal]);

  const list = useMemo(() => {
    if (dataSource.length <= 0 || ads.length <= 0) {
      return dataSource;
    }
    return [...ads, ...dataSource];
  }, [dataSource, ads]);

  if (isModal && !scrollableTarget) {
    return null;
  }

  return (
    <BoardList
      dataSource={list}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
      scrollableTarget={scrollableTarget}
    />
  );
}
